<template>
    <div>
      <video ref='videoPlayer' class='video-js'></video>
    </div>
  </template>
  
  <script>
  import videojs from 'video.js'
  import qualitySelector from 'videojs-hls-quality-selector'
  import qualityLevels from 'videojs-contrib-quality-levels'
  
  export default {
    name: 'VideoPlayer',
    props: {
      options: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        player: null
      }
    },
    mounted() {
      videojs.registerPlugin('hlsQualitySelector', qualitySelector)
      videojs.registerPlugin('hlsQualtityLevels', qualityLevels)
      this.player = videojs(
          this.$refs.videoPlayer,
          this.options,
          function onPlayerReady() {
            console.log('onPlayerReady', this)
          }
      ).hlsQualitySelector({ displayCurrentQuality: true })
    },
    beforeDestroy() {
      if (this.player) {
        this.player.dispose()
      }
    }
  }
  </script>
